export const HEADER_MENU_WISHLIST_TEST_ID = 'HEADER_MENU_WISHLIST_TEST_ID';
export const WISHLIST_COMPONENT_TEST_ID = 'WISHLIST_COMPONENT_TEST_ID';
export const AUTH_FROM_WISHLIST_TEST_ID = 'AUTH_FROM_WISHLIST_TEST_ID';
